import axios from "axios";
import apiUrl from "../Apiurl";

export const defaultConflictsUrl = apiUrl + "/prodotti/categories/attribute-rules/default-conflicts";
export const isCancelledRead = (error, signal) => signal?.aborted || error?.code === "ERR_CANCELED";

// Snapshot del wizard: risolvere un elemento non sposta gli indici delle pagine successive.
export async function loadDefaultConflicts(getAuth, signal, site) {
  const items = [];
  let total;
  let page = 1;
  do {
    if (signal.aborted) return [];
    const response = await axios.get(defaultConflictsUrl, {
      ...await getAuth(), signal, params: { page, perPage: 100, site: site || undefined },
    });
    const data = response.data.data;
    items.push(...data.items);
    total = data.total;
    page += 1;
    if (!data.items.length) break;
  } while (items.length < total);
  return items;
}

export async function verifyDefaultConflict(moda, getAuth, signal) {
  const response = await axios.post(defaultConflictsUrl + "/verify", { moda }, {
    ...await getAuth(), signal,
  });
  return response.data.data;
}
